import { Navigate } from 'react-router-dom';
import { auth } from '../services';
import { getHomePathForRole, normalizeRole } from '../utils/roles';

/**
 * AdminRoute Component
 * Only allows access to users with 'admin' role
 */
const AdminRoute = ({ children }) => {
  if (!auth.isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  const user = auth.getUser();
  if (!user) {
    auth.clearAuth();
    return <Navigate to="/login" replace />;
  }

  if (normalizeRole(user.role) !== 'admin') {
    return <Navigate to={getHomePathForRole(user.role)} replace />;
  }

  return children;
};

export default AdminRoute;
